import {gql} from '@apollo/client'

// Whether the calling agent may self-provision Twilio numbers + remaining headroom.
export const TWILIO_PROVISIONING_STATUS = gql`
  query TwilioProvisioningStatus {
    twilioProvisioningStatus {
      enabled
      maxNumbers
      activeCount
      remaining
    }
  }
`

// The agent's active provisioned numbers (personal Caller IDs).
export const MY_PROVISIONED_NUMBERS = gql`
  query MyProvisionedNumbers {
    myProvisionedNumbers {
      id
      e164
      areaCode
      friendlyName
      status
      trunkAttached
      didCreated
      isOutboundCid
      created
    }
  }
`

// Search Twilio's inventory for voice-capable numbers to buy. Read-only.
export const TWILIO_AVAILABLE_NUMBERS = gql`
  query TwilioAvailableNumbers($areaCode: String, $state: String, $country: String, $contains: String, $limit: Int) {
    twilioAvailableNumbers(areaCode: $areaCode, state: $state, country: $country, contains: $contains, limit: $limit) {
      phoneNumber
      friendlyName
      locality
      region
      areaCode
      voice
      sms
    }
  }
`
